<div *ngIf="reportType === 'Office Rep InDetails'"
  id="print-section"
  style="
    font-family: Arial, sans-serif;
    width: 95%;
    margin: 20px auto;
    padding: 0;
    background: #fff;
    border: 1px solid #333;
    border-radius: 6px;
    box-shadow: 0 0 6px rgba(0,0,0,0.2);
    
  "
>

  <!-- ================= HEADER ================= -->
  <table
    style="
      width:100%;
      border-collapse:collapse;
      margin-left:10mm;
      margin-right:10 mm;
      margin:0;
      padding:0;
      border-spacing:0;
    "
  >
    <tr>
      <th colspan="1" style="border:none; font-size: 16px; font-weight: bold; text-align:left; padding:6px;border-bottom:1px solid black;border-right: 1px solid #000; ">
        हिंदुस्तान प्रकाशन संस्था 
      </th>

      <th colspan="3" style="border:none; font-size: 18px; font-weight: bold; text-align:center; padding:6px;border-bottom:1px solid black;border-right: 1px solid #000;">
        Book Payment Receipt Report
      </th>

      <th colspan="5" style="border:none; font-size: 16px; text-align:right; padding:6px;border-bottom:1px solid black;border-right: 1px solid #000;">
        दिनांक {{ currentDate | date:'dd-MM-yyyy' }}
      </th>
    </tr>

    <tr>
      <td colspan="1" style="border:none;font-size: 16px; font-weight:bold; text-align:center;  padding:4px;border-right: 1px solid #000;"> विवेक पुस्तक प्रकाशन</td>

      <td colspan="3" style="border:none; font-size: 16px; font-weight:bold; text-align:center; padding:4px;border-right: 1px solid #000;">
        Rep Very Briefly
      </td>

      <td colspan="5" style="border:none; font-size: 15px;font-weight:bold; text-align:right; padding:4px;border-right: 1px solid #000;">
        Date :From {{ startDate | date:'dd-MM-yyyy' }} To {{ endDate | date:'dd-MM-yyyy' }}
      </td>
    </tr>
  </table>

  <!-- ================= MAIN TABLE ================= -->
  <table
    style="
      width: 100%;
      border-collapse: collapse;
      font-size: 14px;
      margin:0;       /* NO SPACE between two tables */
      padding:0;
      border-spacing:0;
      table-layout: fixed;
    "
  >
    <thead style="background: #f1f1f1; font-weight: bold;">
      <tr>
        <th style="border: 1px solid #000; padding: 8px; width: 70%;">Representative Name</th>
        <th style="border: 1px solid #000; padding: 8px; width: 30%; text-align:center;">Receipt Amount</th>
      </tr>
    </thead>

    <tbody>
      <ng-container *ngFor="let office of PaymentBookOffInDFormBenas">

        <!-- Office Header -->
        <tr style="font-weight: bold;">
          <td colspan="2" style="border: 1px solid #000; padding: 8px;">
            Office Representative: {{ office.office_rep_name }}
          </td>
        </tr>

        <!-- Representative Rows -->
        <tr *ngFor="let rep of office.rep_data">
          <td style="border: 1px solid #000; padding: 8px;">
            {{ rep.rep_name }}
          </td>

          <td style="border: 1px solid #000; padding: 8px; text-align: right;">
            {{ rep.rep_total_rcv  }}
          </td>
        </tr>

        <!-- Office Total -->
        <tr style="background-color: #f4b084; font-weight: bold;">
          <td style="border: 1px solid #000; padding: 8px; text-align: right;">
            Total ({{ office.office_rep_name }})
          </td>

          <td style="border: 1px solid #000; padding: 8px; text-align: right;">
            {{ office.total_rcv_amt  }}
          </td>
        </tr>

      </ng-container>
    </tbody>

    <!-- Grand Total -->
    <!-- <tfoot> -->
      <tr style="background-color: #c8753f; font-weight: bold;">
        <td style="border: 1px solid #000; padding: 10px; text-align: right;">Grand Total:</td>
        <td style="border: 1px solid #000; padding: 10px; text-align: right;">
          {{ PaymentbookOffInDTotal2  }}
        </td>
      </tr>
    <!-- </tfoot> -->
  </table>
</div>

<!-- ================= BUTTONS ================= -->
<div class="noPrint" style="margin-top: 20px; text-align: center;">
  <button mat-raised-button color="accent" (click)=" printPageA4()">🖨️ Print</button>
   <button mat-raised-button color="primary" (click)="exportExcel('Book_InDetail_Officewise')">📊 Export</button>
  <button mat-button mat-dialog-close>❌ Close</button>
</div>
